import { useState } from "react";
import { Link } from "react-router-dom";
import { Dices } from "lucide-react";
import StreakerYourself from "../components/minigames/StreakerYourself";
import Pitch2HitComingSoon from "../components/minigames/Pitch2HitComingSoon";
import FootballMinigame from "../components/minigames/FootballMinigame";

const TABS = [
  { id: "streak",   label: "Streak Yourself", enabled: true },
  { id: "football", label: "Junk Football",   enabled: true },
  { id: "pitch2hit", label: "Pitch2Hit",      enabled: false },
];

// Mirrors the PvPSetup page nav (that one is a local, non-exported component).
function MinigamesNav() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3
                    bg-slate-950/80 backdrop-blur-md border-b border-slate-800/50">
      <Link to="/" className="flex items-center gap-2 font-black text-lg tracking-tight text-white">
        <img src="/favicons32x32.png" alt="" className="w-5 h-5" />
        JUNK <span className="text-amber-400">BALL</span>
      </Link>
      <div className="flex items-center gap-4">
        <Link to="/print-and-play" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Print &amp; Play</Link>
        <Link to="/contact" className="text-xs text-slate-400 hover:text-white transition-colors font-medium">Contact</Link>
      </div>
    </nav>
  );
}

export default function Minigames() {
  const [tab, setTab] = useState("streak");

  return (
    <div className="min-h-screen flex flex-col">
      <MinigamesNav />
      <div className="flex-1 flex flex-col pt-20 pb-12 px-4">
        <div className="mx-auto w-full max-w-3xl py-6">
          <div className="text-center mb-5">
            <p className="text-xs font-bold text-amber-400 tracking-widest uppercase mb-1 flex items-center justify-center gap-1.5">
              <Dices size={13} /> Junk Minigames
            </p>
            <h1 className="text-3xl font-black text-white">Pick a game.</h1>
          </div>

          {/* Tab bar */}
          <div className="flex gap-2 mb-4">
            {TABS.map(t => (
              <button
                key={t.id}
                onClick={() => t.enabled && setTab(t.id)}
                disabled={!t.enabled}
                className={`px-4 py-2 rounded-lg text-sm font-black transition-colors ${
                  tab === t.id
                    ? "bg-amber-500 text-slate-950"
                    : t.enabled
                      ? "bg-slate-800 text-slate-300 hover:bg-slate-700"
                      : "bg-slate-900 text-slate-600 cursor-not-allowed opacity-60"
                }`}
              >
                {t.label}
                {!t.enabled && <span className="ml-1.5 text-[9px] uppercase tracking-wide">Soon</span>}
              </button>
            ))}
          </div>

          {/* Game area — a fixed square frame. MinigameStage scales the
              600×600 design space to fit it, so every minigame looks and plays
              the same here regardless of screen size. */}
          <div className="w-full max-w-[540px] mx-auto aspect-square rounded-2xl border border-slate-800 bg-slate-950/60 overflow-hidden">
            {tab === "streak"    ? <StreakerYourself />  :
           tab === "football" ? <FootballMinigame /> :
                                <Pitch2HitComingSoon />}
          </div>

          {tab === "streak" && (
            <p className="text-center mt-3 text-[11px] text-slate-600">
              Arrow keys to move · hold Space to sprint · reach the glowing exit band before the guards tag you.
            </p>
          )}
          {tab === "football" && (
            <p className="text-center mt-3 text-[11px] text-slate-600">
              Offense: pick formation → HIKE → tap field to throw to nearest receiver · tap to boost runner.
              Defense: tap to surge your blue defenders toward the ball carrier.
            </p>
          )}

          <p className="text-center mt-5 text-xs text-slate-700 tracking-wide italic">
            Every card deserves its day.
          </p>
        </div>
      </div>
    </div>
  );
}
